<div class="card-comment">
  <div class="card-block-small">
    <a [routerLink]="['/profile', vote.voter.username]">
      <img
        *ngIf="vote.voter.image"
        class="voter-image"
        [src]="vote.voter.image"
        alt="voter-image"
      />
      <img
        *ngIf="!vote.voter.image"
        class="voter-image"
        [src]="defaultUserImg"
        alt="voter-image"
      />
    </a>
    <div class="comment-desc">
      <a [routerLink]="['/profile', vote.voter.username]">
        <div class="text-left">
          <h6>{{ vote.voter.username }}</h6>
          <p
            *ngIf="vote.voter.bio"
            class="text-muted"
            [innerHTML]="vote.voter.bio | slice: 0:100"
          ></p>
          <p *ngIf="!vote.voter.bio" class="text-muted">No bio</p>
        </div>
      </a>

      <div class="text-left">
        <i class="text-muted">
          Voted on, {{ vote.createdAt | date: "longDate":"UTC" }}
        </i>
      </div>
    </div>
  </div>
  <hr />
</div>
